module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<fieldset class="cw-fieldset gererrecapitulatifs-commentPopup">\r\n  \r\n    <div class="form-row">\r\n      <div class="col m-0">\r\n        <div class="phx-gererrecapitulatifs-data">\r\n          <div class="form-group">\r\n            <span class="title cw-texteNormal"></span>\r\n          </div>\r\n\r\n          <div class="form-group">\r\n            <label for="commentaire" class="commentLabelStyle" title="'+
((__t=(i18n.t('common:gererrecapitulatifs.commentaire')))==null?'':__t)+
'">'+
((__t=(i18n.t('common:gererrecapitulatifs.commentaire')))==null?'':__t)+
'</label>\r\n            <textarea class="commentaire form-control" rows="6" cols="40" maxlength="200" style="resize:none;"></textarea>\r\n          </div>\r\n        </div>       \r\n      </div>\r\n    </div>\r\n\r\n    <div class="form-row">\r\n      <span class="cwDialog-buttons">\r\n        <button type="button" class="btnOk btn btn-primary btn-withIcon" value="btnOk">'+
((__t=(i18n.t('common:confirmer')))==null?'':__t)+
' '+
((__t=(UTILS.getSVGIcon('valider','',16)))==null?'':__t)+
'</button>\r\n        <button type="button" class="btnAnnuler btn btn-secondary btn-withIcon" value="btnAnnuler">'+
((__t=(i18n.t('common:abort')))==null?'':__t)+
' '+
((__t=(UTILS.getSVGIcon("croix",'',16)))==null?'':__t)+
'</button>\r\n      </span>\r\n    </div>\r\n  \r\n</fieldset>';
}
return __p;
};
